import { AfterViewInit, Component, ContentChild, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { AppComponent } from 'src/app/app.component';
import { isNullOrUndefined } from 'util';


export const VIS_DD_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => VisDropdownlistComponent),
  multi: true
};
@Component({
  selector: 'app-vis-dropdownlist',
  templateUrl: './vis-dropdownlist.component.html',
  styleUrls: ['./vis-dropdownlist.component.css'],
  providers: [VIS_DD_CONTROL_VALUE_ACCESSOR]
})
export class VisDropdownlistComponent implements OnInit, ControlValueAccessor,AfterViewInit {
  @ContentChild(TemplateRef)
  displayTmp: TemplateRef<any>;
  @ViewChild(MatSelect)
  select: MatSelect;

  @Input()
  data: { text: string, value: string | number }[];
  @Input()
  textField: string = 'text';
  @Input()
  valueField: string = 'value';
  @Input()
  valuePrimitive: boolean;
  @Input()
  set disabled(v) {
    if (v !== null && v !== undefined) {
      this._disabled = v;
    }
  }

  @Input()
  set value(v) {
    //允許0通過
    if (v === null || v === false || Number.isNaN(v) || v === undefined) {
      return;
    }
    else {
      this._currentValue = v;
    }
  }
  get value(): any {
    return this._currentValue;
  };
  @Input()
  set readonly(v) {
    this._readonly = v;
  }
  @Input()
  defaultItem: any;
  @Input()
  panelClass: string;
  @Output()
  valueChange: EventEmitter<any> = new EventEmitter(false);
  @Output() blurEvent = new EventEmitter<FocusEvent>();
  @Output() closed = new EventEmitter<void>();
  @Input()
    useCustomTrigger: boolean = false;
  @Input()
    alignEnd: boolean = false;

  _currentValue: any;
  _onChange: (value) => {};
  _onTouched: () => {};
  _disabled: boolean = false;
  _readonly: boolean = false;
  _class: string;
  constructor(private elementRef: ElementRef) {
    elementRef.nativeElement.focus = () => {
      if (!this._disabled) {
        this.select.focus();
      }
    }
  }
  
  ngAfterContentChecked() {
    this._class = this.elementRef.nativeElement.className;
  }

  writeValue(obj: any): void {
    //  if (obj != null) {
    if(this.valuePrimitive){
      this._currentValue = obj;
    }else{
      if(obj && obj[this.valueField]){
        this._currentValue = obj[this.valueField];  
      }else{
        this._currentValue = obj;
      }
    }
    
    //  }
  }
  get selectedItem(): any {
        if (!this.data) {
            return null;
        }
        
        // 【關鍵修正】: 判斷 _currentValue 是否為 null 或 undefined，
        // 允許數值 0 或空字串 '' (如果它是 valueField 的有效值) 通過。
        if (this._currentValue === null || this._currentValue === undefined) {
             return null;
        }

        // 根據 _currentValue (0) 在 data 陣列中查找對應的物件
        // 這裡使用 == 而不是 === 允許 number(0) 匹配 string('0')，如果您的 valueField 是 string
        return this.data.find(item => item[this.valueField] == this._currentValue);
    }
	
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
    if (this._currentValue === null || this._currentValue === undefined) {
      this._currentValue =
        this.defaultItem === undefined ? '' : this.defaultItem[this.valueField];
    }
    
  }
  ngAfterViewInit(): void {
    this.select.openedChange.subscribe(b=>{
      if(b){
        setTimeout(() => {
          var overScale = window.devicePixelRatio>1.5||window.devicePixelRatio<0.75;
          console.log('overScale',overScale, window.devicePixelRatio);
                      var panel = (this.select.panel.nativeElement as HTMLDivElement);
            var cdkOverlayPane = panel.parentElement.parentElement;
          // 確保 zoomFactor 在兩種情況下都被定義
          const zoomFactor = overScale ? (1 / AppComponent.zoom) : 1; 
          
          // 確保在 alignEnd 之前，所有物件尺寸和位置都被取得
          const triggerRect = this.select.trigger.nativeElement.getBoundingClientRect();
          if(overScale){

            cdkOverlayPane.style.minWidth = 'calc('+ cdkOverlayPane.style.minWidth+' * '+ (1/AppComponent.zoom) + ')';
            cdkOverlayPane.style.maxWidth = cdkOverlayPane.style.minWidth;
            cdkOverlayPane.style.width = cdkOverlayPane.style.minWidth;
            cdkOverlayPane.style.top = cdkOverlayPane.offsetTop * (1/AppComponent.zoom) + 'px';
            cdkOverlayPane.style.left = cdkOverlayPane.offsetLeft * (1/AppComponent.zoom) + 'px';
            cdkOverlayPane.style.transform = 'translateX(-14px)';
            //cdkOverlayPane.classList.add('no-min-width');
            panel.style.width = 100+ '%'
            panel.style.maxWidth = cdkOverlayPane.style.minWidth;
            // 會被蓋掉
            panel.style.minWidth = 'unset !important'
          }
          // 只有當 alignEnd 為 true 時才覆寫定位
      if (this.alignEnd) {
 const triggerRect = this.select.trigger.nativeElement.getBoundingClientRect();
    
    // 獲取整個 Viewport/螢幕 的寬度
    const viewportWidth = window.innerWidth; 
    
    // 1. 計算元件距離螢幕右邊緣的原始距離 (未校正縮放)
    // 距離右邊緣 = 螢幕寬度 - 元件右邊緣的 X 座標
    const distanceToViewportRight = viewportWidth - triggerRect.right;
    
    // 2. 進行縮放校正 (將距離乘上 zoomFactor)
    const correctedRightValue = distanceToViewportRight * zoomFactor;

    // 3. 調整 14px 額外偏移（從右邊緣向內縮 14px）
    // 如果 right 屬性的值增加，面板就會向左移動（遠離右邊緣）。
    const finalRightValue = correctedRightValue + 3
    
    
    // --- 應用定位 ---
    
    // 1. 強制取消 left 屬性，讓 right 屬性生效
    cdkOverlayPane.style.setProperty('left', 'unset', 'important');
    
    // 2. 強制設定 right 屬性
    // 將面板的 right 屬性設為元件距離右邊緣的距離，實現右對齊。
    cdkOverlayPane.style.setProperty('right', `${finalRightValue}px`, 'important');

    // 3. 確保 transform 被清除，防止干擾
    // 必須清除 transform，因為它會與 right 屬性衝突
    cdkOverlayPane.style.setProperty('transform', 'none', 'important');
    
    
    // 註：保留您原來的寬度修正，確保面板寬度正確。
    // 如果 overScale=false，下面的寬度修正不會被執行，面板寬度將保持 Material 預設。
    if (overScale) {
        // 寬度修正邏輯
        cdkOverlayPane.style.minWidth = 'calc('+ cdkOverlayPane.style.minWidth+' * '+ zoomFactor + ')';
        cdkOverlayPane.style.maxWidth = cdkOverlayPane.style.minWidth;
        cdkOverlayPane.style.width = cdkOverlayPane.style.minWidth;
        
        // 垂直位置修正
        cdkOverlayPane.style.top = cdkOverlayPane.offsetTop * zoomFactor + 'px';
    }
          }
        }, 0);
      }else{
        this.closed.emit();   // ✅ 加這行，把關閉事件發給父元件
      }
    })
  }
  _valueChange(evt: MatSelectChange) {
    this._currentValue = evt.value;
    if (this._onChange) {
      this._onChange(evt.value)
    }
    setTimeout(() => {
      if (this.valuePrimitive) {
        this.valueChange.emit(evt.value);
      } else {
        var seletcedItem = this.data.find(d => d[this.valueField] == evt.value);
        this.valueChange.emit(seletcedItem);
      }
    }, 0);

  }
  focusAndOpen() {
  this.select.open(); // 或 this.select.open();
  }
  onClose(){

  }
  onBlur(event: FocusEvent) {
    // 當整個 component 失焦時觸發
    this.blurEvent.emit(event);
  }
}
